(() => {
  const trigger = document.getElementById('pk-chosen-pieces-cart-trigger');
  if (!trigger) return;

  const gatewaySelector = '[data-pk-oracle-dialog]';

  function isGatewayOpen() {
    const gateway = document.querySelector(gatewaySelector);
    return Boolean(gateway && !gateway.hidden);
  }

  function syncTrigger() {
    trigger.hidden = Boolean(isGatewayOpen());
  }

  function syncTriggerCount(count) {
    const hasAuthoritativeCount = typeof count === 'number';
    const parsedCount = Number.parseInt(count, 10);
    const visibleCount = Number.isFinite(parsedCount) && parsedCount > 0 ? String(parsedCount) : '';
    const headerCount = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    const headerCountLabel = document.querySelector('#cart-icon-bubble .cart-count-bubble .visually-hidden');
    const fallbackCount = headerCount
      ? headerCount.textContent.trim()
      : headerCountLabel?.textContent.match(/\d+/)?.[0] || '';
    const badge = trigger.querySelector('[data-pk-chosen-pieces-cart-count]');
    const nextCount = hasAuthoritativeCount ? visibleCount : fallbackCount;
    const label = nextCount
      ? `Open your chosen pieces cart, ${nextCount} items`
      : 'Open your chosen pieces cart';

    trigger.setAttribute('aria-label', label);
    trigger.querySelector('.visually-hidden').textContent = label;

    if (!nextCount) {
      badge?.remove();
      return;
    }

    if (badge) {
      badge.textContent = nextCount;
      return;
    }

    const nextBadge = document.createElement('span');
    nextBadge.className = 'pk-chosen-pieces-cart-trigger__count';
    nextBadge.dataset.pkChosenPiecesCartCount = '';
    nextBadge.setAttribute('aria-hidden', 'true');
    nextBadge.textContent = nextCount;
    trigger.append(nextBadge);
  }

  trigger.addEventListener('click', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.open(trigger);
    else window.location.assign('/cart');
  });

  const gateway = document.querySelector(gatewaySelector);
  if (gateway) {
    new MutationObserver(syncTrigger).observe(gateway, {
      attributes: true,
      attributeFilter: ['hidden'],
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (typeof event?.cartData?.item_count === 'number') {
        syncTriggerCount(event.cartData.item_count);
      }
    });
  }

  syncTrigger();
  syncTriggerCount();
})();
